import React, { useState, useEffect } from "react";
import data from "../components/data.json";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const Projects = () => {
    // const location = useLocation();
    const navigate = useNavigate();
    // const searchParams = new URLSearchParams(location.search);
    // const slugg = searchParams.toString()
    // const slug = (slugg.slice(0, -1));
    // const [activeTab,setActiveTab] = useState('all')
    const [selectedTag, setSelectedTag] = useState("all");

    const handleClick = (tag) => {
        setSelectedTag(tag);
        // setActiveTab(tag);
        navigate(`/projects?${tag}`);
    };
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        if (selectedTag === "all") {
            navigate(`/projects`);
        }
        // eslint-disable-next-line
    }, []);

    function shuffle(array) {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    }

    const filteredItems =
        selectedTag === "all"
            ? data.items
            : data.items.filter((item) => item.tag.includes(selectedTag));

    const shuffledItems = shuffle(filteredItems);

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0, transition: { duration: 5 } }}
            transition={{ duration: 1, ease: "easeInOut" }}
        >
            <div className="m-auto mt-12 w-full text-center uppercase">
                <h1 className=" text-xl mt-6 tracking-[2.8px] text-white text-center">
                    Things
                </h1>
                <p className="tracking-[5px] text-sm text-white/60 mt-1">
                    I've Built in the past
                </p>
            </div>
            <Link
                to="/"
                className="bg-white/10 rounded-full p-2 px-4 text-xs m-auto text-center text-white block hover:bg-mx-yellow transition-all duration-300 ease-in-out w-fit my-10"
            >
                {" "}
                Back to Home
            </Link>
            <div className="flex gap-2 mb-12 mt-16 md:gap-4 m-auto m-11/12 md:w-10/12 justify-center flex-wrap font-semibold">
                <button
                    className={`${
                        selectedTag !== "all"
                            ? "bg-white/10 text-white"
                            : "bg-white text-black "
                    } p-2 px-4 rounded-full uppercase transition-all duration-300 ease-in-out`}
                    onClick={() => handleClick("all")}
                >
                    All
                </button>
                {data.tags.map((tag, index) => (
                    <button
                        className={
                            selectedTag === tag
                                ? "p-2 px-4 font-medium text-sm text-black bg-white rounded-full uppercase"
                                : "p-2 px-4 font-medium text-white text-sm bg-white/10 hover:bg-white/[0.05] transition-all duration-300 ease-in-out rounded-full uppercase"
                        }
                        key={index}
                        onClick={() => {
                            handleClick(tag);
                            shuffle();
                        }}
                    >
                        {tag}
                    </button>
                ))}
            </div>

            <div className=" w-11/12 m-auto md:w-1/2 h-full overflow-y-scroll snap-normal snap-proximity scroll-smooth snap-y md:snap-none">
                <div>
                    {shuffledItems.map((item) => (
                        <AnimatePresence>
                            <motion.a
                                key={item.link}
                                target="_blank"
                                initial={{ opacity: 0 }}
                                whileInView={{ opacity: "100" }}
                                href={item.link}
                                className="bg-white/90 flex my-5 group items-center justify-center flex-col hover:bg-white anim relative m-auto drop-shadow-xl cursor-pointer rounded-xl p-8 md:p-10 overflow-hidden snap-start md:snap-none"
                            >
                                <h3 className="text-sm font-semibold md:text-lg lg:text-xl">
                                    {item.name} ↗
                                </h3>
                                <p className="text-[0.8rem] max-w-[80%] text-center md:text-sm opacity-60 mt-2">
                                    {item.description}
                                </p>
                                <p className="text-white/10 group-hover:text-blue-800 mt-3 text-[0.6rem] transition-all duration-300 ease-in-out ">{`${item.tag}`}</p>
                            </motion.a>
                        </AnimatePresence>
                    ))}
                </div>
            </div>
        </motion.div>
    );
};

export default Projects;
